/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    value20: "",
    value20a: "",
    value21: "",
    value21a: "",
    value21b: "",
    value22a: "",
    value22b: "",
    value23: "",
    value24: "",
  },
];

function TaxPersonalTable3({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value20: "",
      value20a: "",
      value21: "",
      value21a: "",
      value21b: "",
      value22a: "",
      value22b: "",
      value23: "",
      value24: "",
    };

    setData((prev) => [...prev, newRow]);
  };

  const handleChangeSelect = (id, name, value) => {
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">
        II. Phân bố thuế thu nhập cá nhân đối với thu nhập từ trúng thưởng xổ số điện toán:
      </Typography>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={2}
                style={{ textAlign: "center", background: "#f4f4f4", minWidth: 0 }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Loại chi tiêu
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Địa bàn hoạt động sản xuất, kinh doanh
              </Td>
              <Td rowSpan={1} colSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Thu nhập tính thuế cho cá nhân
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số thuế TNCN đã khấu trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Tỉnh
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Huyện
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Cơ quan thuế cấp cục
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", background: "#f4f4f4", minWidth: 0 }}>[20]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}></Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[21]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[21b]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[21b]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }} colSpan={2}>
                [22]
              </Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[23]</Td>
              <Td style={{ textAlign: "center", background: "#f4f4f4" }}>[24]</Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  style={{ textAlign: "center", minWidth: 0, width: 10 }}
                >
                  {index + 1}

                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value20a", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value21"
                    value={item.value21}
                    onChange={handleChange}
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value21a", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value21b", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value22a", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeSelect(item.id, "value22b", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value23"
                    value={item.value23}
                    onChange={handleChange}
                  />
                </Td>
                <Td style={{ textAlign: "center" }}>
                  <InputTable
                    id={item.id}
                    name="value24"
                    value={item.value24}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td colSpan={7} style={{ textAlign: "center", background: "#ddeff3" }}>
                Tổng cộng
              </Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>0</Td>
              <Td style={{ textAlign: "center", background: "#ddeff3" }}>0</Td>
            </tr>
          </tbody>
        </table>
      </Box>
      <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
        <SoftButton variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </SoftBox>
    </Box>
  );
}

export default memo(TaxPersonalTable3);

function InputTable(props) {
  const { id, onChange, type, name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    }
    if (type === "text") {
      onChange({ id, value, name, type });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type && type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
